module.exports = __webpack_public_path__ + "static/media/slidebar_btn.1452331c.svg";